// Only authenticated, inline branding is eligible. Decode before either renderer
// reserves space; never fetch arbitrary URLs or substitute another brand asset.
export async function decodeSynthesisLogo(branding) {
  const source = branding?.enabled ? branding.logo : null;
  if (typeof source !== 'string' || source.length > 8 * 1024 * 1024 || !/^data:image\/(png|jpeg|webp);base64,[a-z0-9+/=\s]+$/i.test(source)) return null;
  return new Promise(resolve => {
    const image = new Image();
    let finished = false;
    const finish = value => { if (!finished) { finished = true; clearTimeout(timer); image.onload = image.onerror = null; resolve(value); } };
    const timer = setTimeout(() => finish(null), 3000);
    image.onerror = () => finish(null);
    image.onload = () => {
      try {
        const width = image.naturalWidth, height = image.naturalHeight;
        if (!width || !height || width * height > 16000000) return finish(null);
        const canvas = document.createElement('canvas');
        canvas.width = width; canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0);
        finish({src: canvas.toDataURL('image/png'), width, height});
      } catch { finish(null); }
    };
    image.src = source;
  });
}
